var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","max-width":"1000px","max-height":"800px","width":"auto"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._t("default",null,null,{ close: _vm.close })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }